// JS override for constant countries.
// Keep this file simple and JS-native so it can be statically imported from plain .js code.
export const CountryEnum = {
  URT: 'URT'
};

export const CountryMeta = {
  URT: { id: 99, labels: { french: 'AFRICA', english: 'AFRICA', portugais: 'AFRICA', swahili: 'AFRICA' } }
};

export const getLabel = (code, lang = 'french') =>
  (CountryMeta[code] && CountryMeta[code].labels && CountryMeta[code].labels[lang]) || code;

export const getId = (code) => (CountryMeta[code] && CountryMeta[code].id) || -1;

export const fromId = (id) => Object.keys(CountryMeta).find(c => CountryMeta[c].id === id) || null;

export const options = (lang = 'french') =>
  Object.keys(CountryEnum).map(code => ({ code, id: getId(code), label: getLabel(code, lang) }));

// Enable to merge these constant countries into API results
export const show = true;
